import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Suspense, lazy, useEffect } from "react";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import LoadingSpinner from "./components/LoadingSpinner";
import { ThemeProvider } from "./components/ThemeProvider";

// Lazy loaded pages
const Home = lazy(() => import("./pages/Home"));
const AboutUs = lazy(() => import("./pages/AboutUs"));
const Services = lazy(() => import("./pages/Services"));
const WhoWeAre = lazy(() => import("./pages/WhoWeAre"));
const ContactUs = lazy(() => import("./pages/ContactUs"));
const PreOrder = lazy(() => import("./pages/PreOrder"));
const OrderTracking = lazy(() => import("./pages/OrderTracking"));
const OrderBooking = lazy(() => import("./pages/OrderBooking"));
const UserProfile = lazy(() => import("./pages/UserProfile"));

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider defaultTheme="light" storageKey="yatra-theme">
        <AppContent />
      </ThemeProvider>
    </BrowserRouter>
  );
}

function AppContent() {

useEffect(() => {
    if (process.env.NODE_ENV !== "production") return;
    
    const blockContextMenu = (e) => e.preventDefault();
    const blockTextSelect = (e) => e.preventDefault();

    const blockKeys = (e) => {
      const blockedKeys = [
        "F12",
        "Control+Shift+I",
        "Control+Shift+J",
        "Control+Shift+C",
        "Control+U",
        "Control+S",
      ];
      const keyCombo =
        (e.ctrlKey ? "Control+" : "") +
        (e.shiftKey ? "Shift+" : "") +
        (e.key.length === 1 ? e.key.toUpperCase() : e.key);

      if (blockedKeys.includes(keyCombo)) {
        e.preventDefault();
      }
    };

    document.addEventListener("contextmenu", blockContextMenu);
    document.addEventListener("selectstart", blockTextSelect);
    document.addEventListener("keydown", blockKeys);

    return () => {
      document.removeEventListener("contextmenu", blockContextMenu);
      document.removeEventListener("selectstart", blockTextSelect);
      document.removeEventListener("keydown", blockKeys);
    };
  }, []);
  
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow">
        <Suspense fallback={<LoadingSpinner />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/services" element={<Services />} />
            <Route path="/who-we-are" element={<WhoWeAre />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/pre-order" element={<PreOrder />} />
            <Route path="/order-booking" element={<OrderBooking />} />
            <Route path="/order-tracking" element={<OrderTracking />} />
            <Route path="/user-profile" element={<UserProfile />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}

export default App;
